<template>
	<main>
		<div class="container-fluid mt-4 px-3 px-md-4" id="home_header">
			<!-- Mise en avant PAX (si option activée) -->
			<div v-if="hasPaxAccess" class="mb-4">
				<HomePAX />
			</div>

			<!-- Blocs contrats + factures -->
			<div class="row">
				<div v-if="hasSaillieAccess" class="col-12 col-lg-6 mb-4">
					<div class="home-card">
						<HomeContracts />
					</div>
				</div>
				<div v-if="hasFacturationAccess" class="col-12 col-lg-6 mb-4">
					<div class="home-card">
						<HomeInvoices />
					</div>
				</div>
			</div>
		</div>
	</main>
</template>

<script type="text/javascript">
	export default {
		name: 'HomeMenu',

		computed: {
			hasPaxAccess() {
				return this.$store.state.userAccess.hasPaxAccess
			},
			hasSaillieAccess() {
				return this.$store.state.userAccess.hasSaillieAccess
			},
			hasFacturationAccess() {
				return this.$store.state.userAccess.hasFacturationAccess
			},
		},

		components: {
			HomePAX:       () => import('@/components/Pax/Home'),
			HomeContracts: () => import('@/components/Home/HomeContracts'),
			HomeInvoices:  () => import('@/components/Home/HomeInvoices'),
		},
	}
</script>

<style scoped>
.home-card {
	border: 1px solid var(--primary);
	border-radius: 0.5rem;
	padding: 1rem;
}
</style>